<template>
  <div class="box">
    <div class="box-content box-map text-center">
      <img src="@/assets/images/position.png" alt="Ma position" class="position-icon">
      <div class="title">Paris et petite couronne</div>
    </div>
  </div>
</template>
